import { render, staticRenderFns } from "./SignatureEditDocument.vue?vue&type=template&id=fb8a9784&scoped=true&"
import script from "./SignatureEditDocument.vue?vue&type=script&lang=js&"
export * from "./SignatureEditDocument.vue?vue&type=script&lang=js&"
import style0 from "./SignatureEditDocument.vue?vue&type=style&index=0&id=fb8a9784&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb8a9784",
  null
  
)

export default component.exports